import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AdditionalbaseService } from '../common/additionalbase.service';
import { NotifyService } from '../notify/notify.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  public token: string;
  public simulation: boolean = false;
  public credentials: any = {};

  constructor(
    public httpClient: HttpClient,
    public _additionalService: AdditionalbaseService,
    private _notifyService: NotifyService) {

  }

  restore(Obj) {
    return this.request('post', '/v1/User/Password', Obj);
  }

  password(Obj) {
    return this.request('put', '/v1/User/Password', Obj);
  }

  getOptions() {
    const token = localStorage.getItem('token');

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    if (token && token !== "null") {
      headers = headers.append('Authorization', token);
    }

    return { headers: headers };
  }

  request(method: any, url: string, _object?: any, headers?: any) {

    let requestTrigger: any;
    const request: Observable<any> = new Observable<any>(
      observable => {
        requestTrigger = observable;
      }
    );
    let fullUrl: string;
    fullUrl = environment.endpoint_auth + url;

    let httpRequest;

    if (method === 'post') {
      httpRequest = this.httpClient.post(fullUrl, _object, this.getOptions());
    }

    if (method === 'put') {
      httpRequest = this.httpClient.put(fullUrl, _object, this.getOptions());
    }

    httpRequest.pipe().subscribe(
      (response: any) => {
        requestTrigger.next(response);
        requestTrigger.complete();
      },
      (err: any) => {
        requestTrigger.next(err);
        requestTrigger.complete();
      }
    );


    return request;
  }
}
